import React, { Component } from 'react';
import { AchievementBadge } from '../../components';
import './ProfileAchievements.scss';

class ProfileAchievements extends Component {
  numberOfEarnedAchievements() {
    if (this.props.achievements) {
      return this.props.achievements.length + "/11";
    } else return '';
  }

  renderAchievements() {
    const { achievements } = this.props;
    return achievements.map((achievement, i) => (
      <AchievementBadge
        key={i}
        name={achievement.name}
        description={achievement.description}
        picture={achievement.picture}
      />
    ));
  }

  render() {
    return (
      <div>
        <div className="achievements-header">
          <div>Achievements</div>
          <div className="num-completed">{this.numberOfEarnedAchievements()}</div>
        </div>
        <div className="achievements-container">
          {this.renderAchievements()}
        </div>
      </div>
    );
  }
}

export default ProfileAchievements;


// WEBPACK FOOTER //
// ./src/screens/profile/ProfileAchievements.js